// extracted by mini-css-extract-plugin
export default {"side_cell":"TargetLine_side_cell__mVbWM","main_cell":"TargetLine_main_cell__k6AuE"};